import { createSlice } from "@reduxjs/toolkit";
import { reducers } from "../../constants/appConstants";

const initialState = {
  data: [],
};

export const notificationSlice = createSlice({
  name: reducers.notifications,
  initialState,
  reducers: {
    saveData: (state, action) => {
      state.data = action.payload;
    },
    updateData: (state, action) => {
      state.data = [...state.data, action.payload];
    },
    clearNotifications: (state) => {
      state.data = [];
    },
  },
});

export const { clearNotifications, saveData, updateData } =
  notificationSlice.actions;

export default notificationSlice;
